/* ============================================
   ALANKAR — Global animations (fade-up on scroll)
   ============================================ */
(function() {
  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.alk-fade-up').forEach(function(el) { el.classList.add('alk-in-view'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('alk-in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
  document.querySelectorAll('.alk-fade-up').forEach(function(el) { observer.observe(el); });

  // Re-init when new content is added (Shopify section reload)
  document.addEventListener('shopify:section:load', function(e) {
    e.target.querySelectorAll('.alk-fade-up').forEach(function(el) { observer.observe(el); });
  });
})();
